import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { isArray } from "lodash";


export function atLeastOneCheckboxCheckedValidator(minRequired = 1): any {
    return function validate(formGroup: FormGroup) {
        let checked = 0;

        Object.keys(formGroup.controls).forEach(key => {
            const control = formGroup.controls[key];

            if (control.value === true) {
                checked++;
            }
        });

        if (checked < minRequired) {
            return {
                requireCheckboxToBeChecked: true,
            };
        }

        return null;
    };
}

export class RegExpValidation {
    public errorName: string;
    public pattern: RegExp | string;
    
    constructor(errorName: string, pattern: RegExp | string) {
        this.errorName = errorName;
        this.pattern = pattern;
    }
}

export class CustomValidators {
    static stringIsNotEmpty(): ValidatorFn {
        return (formControl: AbstractControl): ValidationErrors | null => {
            let validationError: ValidationErrors | null = null;
    
            let cleanRegEx = new RegExp('(\W|\n|\r|\t|\s)', 'g')
            let cleanString = formControl.value.replaceAll(cleanRegEx, '');
            
            if (cleanString == '') {
                validationError = { StringIsEmpty: true }
            }
    
            return validationError;
        };
    }

    static regexMultiPatternValidator(regExpValidations: RegExpValidation[]): ValidatorFn {
        return (formControl: AbstractControl): ValidationErrors | null => {
            let validationError: ValidationErrors | null = null;

            regExpValidations.forEach((validation: RegExpValidation) => {
                let regEx = new RegExp(validation.pattern);

                if (!regEx.test(formControl.value)) {
                    if (validationError == null) {
                        validationError = { DoesNotMatchPattern: { value: formControl.value } };
                    }

                    validationError[validation.errorName] = true;
                }
            })

            return validationError;
        };
    }

    static valueIsInArray(validValuesArray: Array<string | number>): ValidatorFn {
        return (formControl: AbstractControl<number | string>): ValidationErrors | null => {
            let validationError: ValidationErrors | null = null;
            
            if (isArray(formControl.value)) {
                let formValueHasInvalidValues = false;
                let invalidValues: any[] = []
                
                formControl.value.forEach( (valueToCheck) => {
                    if (!validValuesArray.includes(valueToCheck)) {
                        formValueHasInvalidValues = true;
                        invalidValues.push(valueToCheck);
                    }
                } )

                if (formValueHasInvalidValues) {
                    validationError = { DoesNotMatchExpectedValues: { value: invalidValues } }
                }
                
            } else {
                if (!validValuesArray.includes(formControl.value)) {
                    validationError = { DoesNotMatchExpectedValues: { value: formControl.value } }
                }
            }
            
            return validationError;
        };
    }
}